import { UIActionType } from "../action-types/UIActionType";

const initialState = {
  snackbar: {
    open: false,
    severity: "success",
    message: "",
    transactionHash: "",
  },

  email: "",
  network: 0,
  admin: false,
  theme: "light",
  loading: false,
  isDataFetched: true,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UIActionType.SET_IS_DATA_FETCHED: {
      return {
        ...state,
        isDataFetched: action.payload,
      };
    }
    case UIActionType.SET_SNACKBAR:
      return {
        ...state,
        snackbar: action.payload,
      };

    case UIActionType.SET_EMAIL:
      return {
        ...state,
        email: action.payload.email,
        admin: action.payload.admin,
      };

    case UIActionType.SET_NETWORK:
      return {
        ...state,
        network: action.payload,
      };

    case UIActionType.SET_THEME:
      return {
        ...state,
        theme: action.payload,
      };

    case UIActionType.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case UIActionType.RESET_UI_DATA:
      return initialState;

    case "ON_BORROW":
      return {
        ...state,
        rented: action.payload,
      };

    case "ON_LEND":
      return {
        ...state,
        lended: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
